import React, { useState } from 'react';
import styled from 'styled-components';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { goToNextState } from '../../../helpers/goToNextState';
import { goToPreviousState } from '../../../helpers/goToPreviousState';
// import { isFinalState } from '../../../helpers/isFinalState';
import { isInitialState } from '../../../helpers/isInitialState';
import { stateHasValue } from '../../../helpers/stateHasValue';
// import { ArrowDown, ArrowUp } from '../../Icon';
import { isCurrentState } from '../../../helpers/isCurrentState';

const StyledButtonsWrpper = styled.div`
  width: 100%;
  min-height: 70px;
  justify-content: space-between;
  align-items: flex-start;
  overflow: hidden;

  @media (min-width: 768px) {
    display: flex;
  }
  @media (min-width: 1441px) and (max-width: 1960px) {
    min-height: 70px!important;
  }
  @media (min-width: 1441px) {
    padding: 5px 64px;
  }
  @media (max-width: 1440px) {
    padding: 5px 25px;
  }
  @media (max-width: 1023px) {
    min-height: 70px;
  }
`;

const StyledBackButton = styled.button`
  z-index: 9;
  color: rgb(27, 49, 85);
  cursor: pointer;
  background: transparent;
  font: bold 16px / 22px Lato;
  letter-spacing: normal;
  height: 44px;
  width: 100%;
  max-width: 150px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 2px solid rgb(27, 49, 85);
  border-radius: 25px;
  text-transform: uppercase;
  padding: 0px 15px;
  font-size: var(--bs-sm-font-size);

  svg {
    width: 12px;
    margin: 0px 0px 0px 15px;
    path {
      fill: #1b3155;
    }
  }

  &:active,
  *:active,
  &:focus,
  *:focus {
    outline: 0;
  }

  &[disabled] {
    * {
      opacity: 0.6;
    }
    cursor: not-allowed;
    border: 2px solid #dddcda;
    color: #dddcda;
  }
`;

const StyledNextButton = styled.button`
  z-index: 9;
  color: rgb(255, 255, 255);
  cursor: pointer;
  background: rgb(27, 49, 85);
  font: bold 16px / 22px Lato;
  letter-spacing: normal;
  height: 44px;
  width: 100%;
  max-width: 150px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 25px;
  text-transform: uppercase;
  font-size: var(--bs-sm-font-size);
  padding: 0px 15px;

  svg {
    width: 12px;
    margin: 0px 0px 0px 15px;
    path {
      fill: #1b3155;
    }
  }

  &:active,
  *:active,
  &:focus,
  *:focus {
    outline: 0;
  }

  &[disabled] {
    * {
      opacity: 1;
    }
    cursor: not-allowed;
    background: #d3d7df;
    color: #fff;
    border: 1px solid #d3d7df;
  }
`;

interface NavigationLargeProps {
  onBackClick?: () => void;
}

export const NavigationLarge: React.FC<NavigationLargeProps> = ({ onBackClick }) => {
  const [state, send] = useService(productBuilderMachine);

  let smartReleaseStateStatus =
    isCurrentState('smartRelease', state) &&
    typeof state.context.custom.smartRelease === 'string' &&
    state.context.custom.smartRelease !== 'no';

  const handleBackClick = () => {
    // Call the parent callback if provided
    if (onBackClick) {
      onBackClick();
    }
    // Execute the original back navigation
    goToPreviousState(state, send)();
  };

  return (
    <StyledButtonsWrpper>
      <StyledBackButton
        onClick={handleBackClick}
        disabled={isInitialState(state)}
      >
        <span>
          Back
          {/* <ArrowUp /> */}
        </span>
      </StyledBackButton>
      {/* {!isFinalState(state) && ( */}
      <StyledNextButton
        onClick={goToNextState(state, send)}
        disabled={
          !stateHasValue(state) ||
          smartReleaseStateStatus ||
          state.matches('measurements.loading') ||
          state.matches('measurements.failure')
        }
      >
        <span>
          Next
          {/* <ArrowDown /> */}
        </span>
      </StyledNextButton>
      {/* )} */}
    </StyledButtonsWrpper>
  );
};
